import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { MdfAllocationUpdateInput } from "@colab/shared";

// PATCH /api/admin/mdf/allocations/:id
//
// Replaces /app/admin/mdf/_actions.ts::updateAllocationAction. Pessimistic.
// Caller passes `fundId` for invalidation targeting (parent fund-detail
// page surfaces the allocation list).
type Vars = {
  id: string;
  fundId: string;
  input: MdfAllocationUpdateInput;
};

export function useUpdateAllocation() {
  const queryClient = useQueryClient();
  return useMutation<{ ok: true }, ApiClientError, Vars>({
    mutationFn: ({ id, input }) =>
      apiFetch<{ ok: true }>(`/admin/mdf/allocations/${id}`, {
        method: "PATCH",
        body: JSON.stringify(input),
      }),
    onSuccess: (_data, { fundId }) => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.mdf.fund(fundId) });
    },
    onError: (err) => {
      toast.error(err.message ?? "Failed to update allocation");
    },
  });
}
